<template>
	<WebViewLayout class="bg-color-gold-light">
		<ProHero />
		<MoreHandsOnSection />
		<ImportantDetailsSection />
	</WebViewLayout>
</template>

<script setup lang="ts">
import ImportantDetailsSection from '@components/marketing-site/fundrise-pro/important-details-section.vue';
import MoreHandsOnSection from '@components/marketing-site/fundrise-pro/more-hands-on-section.vue';
import ProHero from '@components/marketing-site/fundrise-pro/pro-hero.vue';
import WebViewLayout from '@views/webview/web-view-layout.vue';
</script>
